import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import Local from "model/patrimonio/Local";
import Deposito from "model/suprimentos/Deposito";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import LocalService from "service/patrimonio/LocalService";

const localService = new LocalService();

export default function LocalCadastro() {

    const [queryParameters] = useSearchParams();

    const {control, clearErrors, setError, setFocus, register, formState: {errors}} = useForm();

    const [local, setLocal] = useState<Local>(new Local());
    const [titulo, setTitulo] = useState<string>('Local');
    const [editando, setEditando] = useState<boolean>(false);

    const inputNomeRef = useRef<any>(null);

    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }
    },[])

    function validar() {

       if (!local.nome) {
            setError("nome", {type: "manual", message: "Nome é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={local} novoCadastro getNewModel={()=>new Local()} service={localService} setModel={(value: Local) => setLocal(value)} validar={() => validar()} urlService="/local" pathCadastro="/local" tituloPagina={'Local'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={local.ativo}
                    onChange={(e) => setLocal({ ...local, ativo: e.target.checked as boolean })}
                    style={{ marginRight: 5 }} />
                <label>Ativo</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText 
                        required value={local.nome}
                        className={errors.nome ? "p-invalid" : ""} 
                        style={{ width: '100%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setLocal({ ...local, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>
            
            <div className="row">
                <Label className="col col-sm-12">Descrição</Label>
                <div className="col-sm-12">
                    <InputText 
                        required value={local.descricao}
                        className={errors.descricao ? "p-invalid" : ""} 
                        style={{ width: '100%' }}
                        {...register("descricao", {
                            onChange: (e) => {
                                setLocal({ ...local, descricao: e.target.value })
                                clearErrors("descricao")
                            }
                        })}
                    />
                </div>
                {errors.descricao && errors.descricao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.descricao?.message as string}</span> : null}
            </div>
        </BaseCadastro>
    )
}